export default "__VITE_ASSET__ChiONPGq__"